import React, { useState } from "react";
import "./Register.css";
import { Link, useNavigate } from "react-router-dom";
import { useRegisterMutation } from "../../Redux/Api/AuthApi";
import { useDispatch } from "react-redux";
import { credential } from "../../Redux/Slice/AuthSlice";
import NavBar from "../../Component/NavBar/NavBar";


const Register = () => {
  const [Err, setErrMsg] = useState();
  const [terms,setTerms] = useState(false)
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    age:"",
    mobile: "",
    confirm:"",
    parentPhone: "",
    paymentOption:"",
    parentName: "",
    discipline: "",
    gymnasticLevel: "",
  });

  const [register, { isError, isLoading,}] = useRegisterMutation()
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleTerms = (e)=>{
     let checked = e.target.checked
      if (checked){
        setTerms(true)
      }else{
        setTerms(false)
      }
   }

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleRegister = async (e) => {
    e.preventDefault();
      if(terms === false){
        setErrMsg('Please, agree to terms and condition')
      }else{
         if(formData.confirm === formData.password){
          try {
            const response = await register({
              name: formData.name,
              email: formData.email,
              password: formData.password,
              parentName: formData.parentName,
              parentPhone: formData.parentPhone,
              paymentOption: formData.paymentOption,
              gymnasticLevel: formData.gymnasticLevel,
              age:formData.age,
              discipline: formData.discipline,
            });
            if (response?.data) {
              const {token,info} = response?.data
              dispatch(credential(JSON.stringify({token,info})));
              navigate("/login")
            }
            if (response.error?.status) {
              setErrMsg(response?.error?.error);
            }
            console.log(response?.error?.error)
          } catch (error) {
            console.log(error);
          }
         }else{
          console.log("Password Doesn't Matched")
         }

      }
  };

  return (
    <div className="register">
      <div className='about-kiga-navbar'>
       <NavBar/>
     </div>
      <div className="register-section">
        <div className="register-terms-condition">
          <div className="register-terms-background">
            <div className="register-title">
              <p>terms and condition</p>
            </div>

            <div className="terms-condition-title">
              <h3>Price And Payment</h3>
              <div className="terms-condition-list">
                <ul>
                  <li>with a month registration each class is 8,000 Rwf</li>
                  <li>
                    with registration for the term each class is 6,000 Rwf
                  </li>
                  <li>
                    A discount of 5% is applied for children attending more than
                    one class per week. this equally applicable for siblings.
                    for siblings attending more than one class per week it is
                    still 5% discount
                  </li>
                  <li>
                    if space permits,children can attend single classes for a
                    drop-in price of 10,000 Rwf / class.
                  </li>
                  <li>
                    the child must be registered and the fees paid before the
                    class starts
                  </li>
                  <li>
                    <b>Payment Can Be Made:</b>
                    <p>
                      by bank transfer to bank account number in equity bank
                      under the account names of kigali international gymnastics
                      academy(K.I.G.A) ltd. please provide proof of payment to
                      our email or when attending a session to momopay account
                      in cash before a session starts
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="terms-condition-title">
              <h3>Register and attendance</h3>
              <div className="terms-condition-list">
                <ul>
                  <li>
                    a register for each class is maintained by the teacher and
                    records student attendance for the purpose of health,safety
                    and security.
                  </li>
                  <li>the max number is 20 children per class</li>
                  <li>
                    all students must be registered for the classes they attend.
                    unregister children will not be allowed to participate in
                    the class. drop-in students may register right before start
                    of class
                  </li>
                  <li>
                    if a class is not attended by the student, it cannot be
                    refunded
                  </li>
                </ul>
              </div>
            </div>
            <div className="terms-condition-title">
              <h3>Liability</h3>
              <div className="terms-condition-list">
                <ul>
                  <li>
                    K.I.G.A does not accept any liability for any loss or damage
                    to property left on the premises
                  </li>
                  <li>
                    coaches are dedicated to ensuring the safety and well being
                    of the children under their supervision,tireless
                    implementing safety protocols and guidelines to any
                    potential risks. however,despite their best efforts,they
                    cannot be held liable the unfortunate event of an injury
                  </li>
                </ul>
              </div>
            </div>
            <div className="terms-condition-title">
              <h3>uniform & punctuality</h3>
              <div className="terms-condition-list">
                <ul>
                  <li>
                    students are required to attend class wearing comfortable
                    and appropriate clothes and to bring a bottle of water (no
                    glass).
                  </li>
                  <li>
                    the student shall arrive at least 5 minutes in advance, so
                    that the student has time to charge{" "}
                  </li>
                  <li>the lesson will start on time</li>
                  <li>
                    parents or assigned caretakers must be there on time at the
                    end of the class,in order to pick up their children K.I.G.A
                    is not responsible for children after the end of the class
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="register-form">
    <div className="register-form-section">
      <form id="form" onSubmit={handleRegister}>
        <div className="reg-form-input">
          <input
            type="text"
            name="name"
            onChange={handleChange}
            placeholder="Child's Full Name*"
            required
          />
        </div>
        <div className="reg-form-input">
          <input
            type="email"
            name="email"
            onChange={handleChange}
            placeholder="Email Address*"
            required
          />
        </div>
        <div className="reg-form-input">
          <input
            type="text"
            name="dob"
            onChange={handleChange}
            placeholder="Date of Birth (e.g. 1/1/2025)"
            required
          />
        </div>
        <div className="reg-form-input">
          <input
            type="password"
            name="password"
            onChange={handleChange}
            placeholder="Password*"
            required
          />
        </div>
        <div className="reg-form-input">
          <input
            type="password"
            name="confirmPassword"
            onChange={handleChange}
            placeholder="Confirm Password*"
            required
          />
        </div>
        <div className="reg-form-input">
          <label htmlFor="parentName">Parent's Full Name</label>
          <input
            type="text"
            name="parentName"
            onChange={handleChange}
            placeholder="e.g. John Wick"
            required
          />
        </div>
        <div className="reg-form-input">
          <label htmlFor="parentPhone">Parent's Mobile Number</label>
          <input
            type="text"
            name="parentPhone"
            onChange={handleChange}
            placeholder="e.g. +250788***88"
            required
          />
        </div>
        <div className="reg-form-input">
          <label htmlFor="childAge">Child's Age</label>
          <input
            type="number"
            name="childAge"
            onChange={handleChange}
            placeholder="e.g. 7"
            required
          />
        </div>
        <div className="reg-form-input">
          <label htmlFor="paymentOption">Payment Options</label>
          <select name="paymentOption" onChange={handleChange} required>
            <option value="">Select a Payment Plan</option>
            <option value="onceWeek">RWF 40,000/Child/month (Once a Week)</option>
            <option value="twiceWeek">RWF 60,000/Child/month (Twice a Week)</option>
            <option value="month">RWF 80,000/Child/month</option>
            <option value="trial">RWF 15,000/Child (Trial Session)</option>
          </select>
        </div>
        <div className="reg-form-input">
          <label htmlFor="discipline">Select Discipline</label>
          <select name="discipline" onChange={handleChange} required>
            <option value="">Select Discipline</option>
            <option value="Foundations of gymnastics">Foundations of Gymnastics</option>
            <option value="Acrobatic">Acrobatic Gymnastics</option>
            <option value="Rhythmic">Rhythmic Gymnastics</option>
            <option value="Tumbling">Tumbling Gymnastics</option>
          </select>
        </div>
        <div className="reg-form-input">
          <label htmlFor="gymnasticLevel">Gymnastics Level</label>
          <select name="gymnasticLevel" onChange={handleChange} required>
            <option value="">Select Level</option>
            <option value="Beginner">Beginner</option>
            <option value="Intermediate">Intermediate</option>
            <option value="Advanced">Advanced</option>
            <option value="Competitive">Competitive</option>
          </select>
        </div>
        <div className="checkbox">
          <input
            type="checkbox"
            name="agree"
            onChange={handleTerms}
            required
          />
          <label htmlFor="condition">
            I agree to the terms and conditions of registration with Kiga.
          </label>
        </div>
        {isError && (
          <div className="error-msg">
            <p>{Err}</p>
          </div>
        )}
        <div className="reg-button">
          {isLoading ? (
            <button type="submit" name="register" disabled>
              Loading...
            </button>
          ) : (
            <button type="submit" name="register">
              Next
            </button>
          )}
        </div>
        <div className="register-inform">
          <p>
            Already have an account? <Link to="/login">Login here</Link>.
          </p>
        </div>
      </form>
    </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
